import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'

import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import type { Bijlage } from '../types/Bijlage'

const headerCells = [
  { id: 'bijlageID', numeric: true, label: 'BijlageID', sort: false },
  { id: 'bestandsnaam', numeric: false, label: 'Bestandsnaam', sort: false },
  { id: 'mimeType', numeric: false, label: 'Mimetype', sort: false },
  { id: 'opties', label: 'Opties', sort: false, fixed: 50 },
]

export interface Props {
  bijlagen?: Bijlage[]
  onClick: (id: string) => void
}

export const Bijlagen = ({ bijlagen, onClick }: Props) => {
  if (!bijlagen || bijlagen.length === 0) {
    return null
  }

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Bijlagen ({bijlagen.length})</Typography>
      </AccordionSummary>

      <StyledTable variant="details" headerCells={headerCells} {...({} as any)}>
        {bijlagen &&
          bijlagen.map((row) => (
            <TableRow key={row.bijlageID}>
              <TableCell>{row.bijlageID}</TableCell>
              <TableCell>{row.bestandsnaam}</TableCell>
              <TableCell>{row.mimeType}</TableCell>
              <TableCell>
                <StyledIconButton
                  title="Bijlage openen"
                  onClick={() => onClick(row.bijlageID)}
                  icon={<CloudDownloadIcon />}
                />
              </TableCell>
            </TableRow>
          ))}
      </StyledTable>
    </Accordion>
  )
}
